import { createSlice } from '@reduxjs/toolkit';

const skills = createSlice({
  name: 'skills',
  initialState: {
    data: [],
    loading: true,
  },
  reducers: {
    hydrateSkills: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
  },
});

export default skills;